export default __webpack_public_path__ + "static/nersc-logo-a19d7b194e310c1bf36879193bb74988.png";